import React from "react";
import { Button, Input } from "../components/Form";
import { BiLogInCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import "./buttonflash.css";
import { useDispatch, useSelector } from "react-redux";
import { setAuthModalOpen } from "../redux/features/authModalSlice";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div
      className="w-full h-screen flex-colo bg-dry"
      style={{
        backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url('/images/nail_hero.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="flex flex-col items-center text-center px-4 py-8"
        onClick={() => dispatch(setAuthModalOpen(true))}
      >
        {/* Heading */}
        <h2 className="mt-4 text-[clamp(2.1rem,7vw,3rem)] font-semibold leading-tight text-center bg-gradient-to-tr from-[#fed693] to-[#ca7100] bg-clip-text text-transparent ">
          Diamond Nail & Beauty
        </h2>
        <div className="border border-yellowlight w-16 m-4"></div>

        <div className="heroneon">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          Admin Login
        </div>
        <p className="text-text italic">Please login to continue</p>

        {/* <div
          className="flex justify-center items-center mt-4"
          onClick={() => dispatch(setAuthModalOpen(true))}
        >
          <div className="relative inline-block px-8 py-4 font-bold text-sm uppercase tracking-widest text-black border border-[#d4af37] rounded-md overflow-hidden group">
            <div className="absolute inset-0 bg-gradient-to-tr from-[#fed693] to-[#ca7100] w-0 h-full transition-all duration-500 ease-in-out group-hover:w-full z-0"></div>
            <span className="relative z-10 text-white group-hover:text-black">
              Log in
            </span>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default Login;
